// @ts-check
import React from 'react'
import cn from 'classnames'
import { Label } from '..'
import { useTranslation } from 'react-i18next'
import styles from './style.css'
/**
 * @param {{
 * name: string,
 * onChange: {(event: React.ChangeEvent): void},
 * value: string,
 * list: OptionProps[],
 * isVertical?: boolean,
 * label: string,
 * isValid: boolean }} props
 */
const RadioGroup = ({ name, onChange, value, list, isVertical = false, label, isValid }) => {
  const { t } = useTranslation()

  return (
    <div className={cn(styles.group, { [styles.vertical]: isVertical })}>
      <div className={styles.label}>
        <Label className={styles.label} htmlFor={name} value={t(label)} valid={isValid} />
      </div>
      <div className={styles.wrapper}>
        {list.map(item => {
          return (
            <RadioButton
              key={`item-${item.value}`}
              label={item.label}
              value={item.value}
              onChange={onChange}
              name={name}
              checked={value === item.value}
            />
          )
        })}
      </div>
    </div>
  )
}

/**
 * @param {{
 * label: string,
 * checked: boolean,
 * onChange: {(event: React.ChangeEvent): void},
 * name: string,
 * value: string
 * }} props
 */
const RadioButton = ({ label, checked, onChange, name, value }) => {
  const { t } = useTranslation()
  return (
    <label className={styles.container}>
      {t(`generatedField.${label}`)}
      <input type='radio' name={name} checked={checked} onChange={onChange} value={value} />
      <span className={styles.checkmark} />
    </label>
  )
}

export { RadioGroup, RadioButton }
